import React, { FC, ReactElement, cloneElement } from "react";
import { Transition } from "react-transition-group";

import { TransitionProps } from "../types";

interface IRevealProps extends Omit<TransitionProps, "timeout"> {
  children: ReactElement;
  timeout?: number;
  oppositeDirection?: boolean;
}

const defaultStyle = (
  duration: number
): Partial<{
  transition: string;
  transform: string;
  transformOrigin: string;
  opacity: number;
}> => ({
  transition: `all ${duration}ms ease-in`,
  transform: `scaleX(0)`,
  opacity: 0,
  transformOrigin: "left",
});

const transitionStyles = {
  entering: { transform: `scaleX(1)`, opacity: 1 },
  entered: { transform: `scaleX(1)`, opacity: 1 },
  exiting: { transform: `scaleX(0)`, opacity: 0 },
  exited: { transform: `scaleX(0)`, opacity: 0 },
};

export const Reveal: FC<IRevealProps> = ({
  in: inProp = false,
  children,
  style,
  timeout = 200,
  ...rest
}) => {
  return (
    <Transition appear in={inProp} timeout={timeout} {...rest}>
      {(state): ReactElement => {
        return cloneElement(children, {
          style: {
            ...defaultStyle(inProp ? timeout : 0),
            ...transitionStyles[state],
            ...style,
            ...children.props.style,
          },
        });
      }}
    </Transition>
  );
};

Reveal.displayName = "Reveal";
